import { call, put, take, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { lopApi } from "../../../api/category/lopApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eLopActionIds } from "../../action-types/category/ILopActions";
const mainAction = rootActions.category.lop;
export function* lopSaga(): any {
    yield takeLatest(eLopActionIds.LOAD_START,loadWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(lopApi.SelectLop);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    }
    else{
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}